module.exports = __webpack_public_path__ + "img/2.1fd1f6e2.png";